// extracted by mini-css-extract-plugin
export default {"zoomModal":"C4-z","image":"D4-z","button":"E4-z","isOverlayShown":"F4-z"};